import { NgbModal, NgbModalOptions } from '@ng-bootstrap/ng-bootstrap';
import { Telefone } from './../../modelos/telefone';
import { Component, OnInit, Input, Output, EventEmitter } from '@angular/core';

@Component({
  selector: 'app-editar-telefone',
  templateUrl: './editar-telefone.component.html',
  styleUrls: ['./editar-telefone.component.css']
})
export class EditarTelefoneComponent implements OnInit {

  @Input() telefone: Telefone;

  @Input() index: number;

  @Output() telefoneEvent: EventEmitter<Telefone>;

  public telefoneCopy: Telefone;

  constructor(private modalService: NgbModal) {
    this.telefoneEvent = new EventEmitter<Telefone>();
  }

  editar(content) {
	const ngbModalOptions: NgbModalOptions = {
		backdrop: 'static',
		keyboard: false,
		windowClass: 'modalTelefone',
		size: 'lg'
	};
    this.telefoneCopy = new Telefone(this.telefone);
    this.modalService.open(content, ngbModalOptions).result.then((result) => {
	  this.telefone = this.telefoneCopy;
	  this.telefoneCopy.index = this.index;
      this.telefoneEvent.emit(this.telefoneCopy);
    }, (reason) => {
    });
  }

  ngOnInit() {
  }

}



// WEBPACK FOOTER //
// C:/Development/Projects/Sun/Flag/workspace/flagvarejoang4/src/app/comum/components/editar-telefone/editar-telefone.component.ts